// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: 'unsaved-messages-modal.title',
        defaultMessage: 'Unsaved Changes'
    },
    description: {
        id: 'unsaved-messages-modal.description',
        defaultMessage: 'You have unsaved changes, are you sure you want to leave?'
    },
    cancel: {
        id: 'unsaved-messages-modal.cancel',
        defaultMessage: 'Cancel'
    },
    continue: {
        id: 'unsaved-messages-modal.continue',
        defaultMessage: 'Continue'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/unsaved-changes-modal/intl.js